import React from 'react';
import { Card, Typography, Space, Button, Tooltip } from 'antd';
import { DragOutlined, EyeInvisibleOutlined, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import useDashboardStore from '../store/useDashboardStore';

const { Text } = Typography;

const DashboardWidget = ({ id, title, children, loading, className = '' }) => {
    const { isCustomizeMode, toggleWidgetVisibility, toggleWidgetSize, widgets, reorderWidgets } = useDashboardStore();
    const widget = widgets.find(w => w.id === id);

    if (!widget || (!widget.visible && !isCustomizeMode)) return null;

    const handleDragStart = (e) => {
        if (!isCustomizeMode) return;
        e.dataTransfer.setData('widgetId', id);
        e.currentTarget.classList.add('widget-dragging');
    };

    const handleDragOver = (e) => {
        if (!isCustomizeMode) return;
        e.preventDefault();
        e.currentTarget.classList.add('widget-drag-over');
    };

    const handleDragLeave = (e) => {
        e.currentTarget.classList.remove('widget-drag-over');
    };

    const handleDrop = (e) => {
        if (!isCustomizeMode) return;
        e.preventDefault();
        e.currentTarget.classList.remove('widget-drag-over');
        const draggedId = e.dataTransfer.getData('widgetId');
        if (draggedId !== id) {
            reorderWidgets(draggedId, id);
        }
    };

    const handleDragEnd = (e) => {
        e.currentTarget.classList.remove('widget-dragging');
    };

    return (
        <Card
            loading={loading}
            className={`premium-card widget-container ${!widget.visible ? 'widget-hidden' : ''} ${isCustomizeMode ? 'widget-edit-mode' : ''} ${className}`}
            draggable={isCustomizeMode}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onDragEnd={handleDragEnd}
            title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space>
                        {isCustomizeMode && <DragOutlined className="widget-drag-handle" />}
                        <span style={{ fontWeight: 700 }}>{title}</span>
                    </Space>
                    {isCustomizeMode && (
                        <Space>
                            <Tooltip title={widget.size === 1 ? 'Expand to 2x' : 'Shrink to 1x'}>
                                <Button
                                    type="text"
                                    size="small"
                                    icon={widget.size === 1 ? <FullscreenOutlined /> : <FullscreenExitOutlined />}
                                    onClick={() => toggleWidgetSize(id)}
                                />
                            </Tooltip>
                            <Tooltip title="Hide Widget">
                                <Button
                                    type="text"
                                    size="small"
                                    danger={!widget.visible}
                                    icon={<EyeInvisibleOutlined />}
                                    onClick={() => toggleWidgetVisibility(id)}
                                />
                            </Tooltip>
                        </Space>
                    )}
                </div>
            }
        >
            <div className="widget-content" style={{ opacity: !widget.visible ? 0.4 : 1 }}>
                {children}
            </div>
            {!widget.visible && isCustomizeMode && (
                <div className="widget-hidden-overlay">
                    <Text type="secondary">Widget Hidden</Text>
                </div>
            )}
        </Card>
    );
};

export default DashboardWidget;
